import { render } from "./MUserListKontraktorPage.vue?vue&type=template&id=2c8bc378&scoped=true"
import script from "./MUserListKontraktorPage.vue?vue&type=script&lang=js"
export * from "./MUserListKontraktorPage.vue?vue&type=script&lang=js"

import "./MUserListKontraktorPage.vue?vue&type=style&index=0&id=2c8bc378&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c8bc378"]])

export default __exports__